/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface QueryForLogCreateRequest {
  name?: string | null;
  note?: string | null;
  context?: object | null;
  statement?: string | null;
  parameters?: object | null;
}

export function QueryForLogCreateRequestFromJSON(
  json: any,
): QueryForLogCreateRequest {
  return QueryForLogCreateRequestFromJSONTyped(json);
}

export function QueryForLogCreateRequestFromJSONTyped(
  json: any,
): QueryForLogCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    name: json["name"],
    note: json["note"],
    context: json["context"],
    statement: json["statement"],
    parameters: json["parameters"],
  };
}

export function QueryForLogCreateRequestToJSON(
  value: QueryForLogCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value.name,
    note: value.note,
    context: value.context,
    statement: value.statement,
    parameters: value.parameters,
  };
}
